import { Flex, Tabs } from '@iheartjane/reefer';
import type { LabeledOption, StoreType } from '@iheartjane/types';
import startCase from 'lodash-es/startCase';

import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';
import { useCustomLanguage } from '@jane/bloom/hooks/useCustomLanguage';

import styles from './storeSwitcherForm.module.css';

export const StoreSwitcherStoreTypes = () => {
  const { medStores, recStores, setStoreType, storeType } = useStoreSwitcher();
  const customLanguage = useCustomLanguage();

  const customRecLanguage =
    customLanguage.storeComplianceLanguageSettings?.['recreational'];

  const recLabel = customRecLanguage
    ? startCase(customRecLanguage)
    : 'Recreational';

  const hasRecStores = recStores.length > 0;
  const hasMedStores = medStores.length > 0;

  let tabs: LabeledOption<StoreType>[];

  if ((hasRecStores && hasMedStores) || (!hasRecStores && !hasMedStores)) {
    tabs = [
      { label: 'All', value: 'all' },
      { label: recLabel, value: 'recreational' },
      { label: 'Medical', value: 'medical' },
    ];
  } else {
    const type = hasRecStores ? 'recreational' : 'medical';
    tabs = [
      { label: type === 'recreational' ? recLabel : 'Medical', value: type },
    ];
    setStoreType(type);
  }

  const selectType = (val: StoreType) => {
    setStoreType(val);
  };

  return (
    <>
      <Flex gap={8} mt={8}>
        <Tabs
          onChange={selectType}
          value={storeType}
          id="store-type-tabs"
          tabWidth="101px"
          full
        >
          {tabs.map((type, i) => (
            <Tabs.Tab
              className={
                storeType === type.value
                  ? styles['formTabSelected']
                  : styles['formTab']
              }
              value={type.value}
              key={i}
              label={type.label}
              selected={storeType === type.value}
            />
          ))}
        </Tabs>
      </Flex>
    </>
  );
};
